import baseUrl from "../lightingApiHost";
import { callApi } from "./util";

const getZones = () => {
  const url = `${baseUrl}zones`;
  return callApi(url);
};

const createZone = zoneName => {
  const url = `${baseUrl}zones`;

  const headers = {
    "Content-Type": "application/json"
  };

  const data = {
    name: zoneName
  };

  const config = {
    headers,
    method: "POST",
    body: JSON.stringify(data)
  };

  return callApi(url, config);
};

export default {
  getZones,
  createZone
};
